import React from 'react';
import { Image } from "react-native"
import type { MyPlayerProps, PlayerBalanceProps } from "../../types"
import { Text, View } from '../../Components/Themed';

type PlayerBalanceCardProps = {
    player_balance:PlayerBalanceProps,
    player:MyPlayerProps
}

const PlayerBalanceCard = ({ player, player_balance }:PlayerBalanceCardProps) => {

    return (
        <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
            <View transparent>
                <Image
                    source={{ uri: player.profile_pic }}
                    style={{ height:35, width:35, borderRadius:100 }}
                    resizeMode='cover'
                />
            </View>
            <View transparent style={{ flex:1, marginLeft:10 }}>
                <Text size={14} theme='h1'>{player.first_name} {player.last_name}</Text>
                <Text style={{ marginTop:3 }} size={12} theme='light'>P{player_balance.promo_balance.toFixed(2)} - E{player_balance.free_market_balance.toFixed(2)}</Text>
            </View>
            <View transparent>
                <Text size={14} theme='h1'>${player_balance.balance.toFixed(2)}</Text>
            </View>
        </View>
    )
}

export default PlayerBalanceCard